module.exports = __webpack_public_path__ + "img/but_bac_on.1b47a34f.png";